<div>
  <div class="form-group has-float-label ms-4">
    <label class="form-label" for="customerAccount"
      >Client Account<span class="madatory-field">*</span></label
    >
    <input
      #inputDrop
      pInputText
      jniAutoCompleteBlocker
      autocomplete="off"
      type="text"
      id="customerAccount"
      name="customerAccount"
      class="form-control"
      [value]="client"
      (input)="customerVendor$.next($any($event.target).value)"
      (keyup)="
        onCustomerSearchOpenToggle(custProgramPopover, $event, inputDrop)
      "
      (keydown.Tab)="getCustomerAccount($event, custProgramPopover)"
      [ngClass]="{ 'has-error': false }"
      (blur)="logValidationErrors()" />
  </div>
  <p-popover
    class="order-dropdown add"
    #custProgramPopover
    aria-labelledby="dropdownBasic1">
    <div class="indropdowntable">
      <p-table
        #dt
        stripedRows
        [rows]="10"
        [size]="'small'"
        scrollHeight="300px"
        [value]="customerLists"
        styleClass="p-datatable-customers order-listing"
        [rowHover]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [paginator]="false"
        [filterDelay]="0"
        styleClass="table-listing popuptable">
        <ng-template pTemplate="header">
          <tr class="table-head">
            <th class="name">Name</th>
            <th class="vaccount">Client Account</th>
            <th class="street" style="width: 100px" pSortableColumn="street">
              Street
              <p-sortIcon field="street"></p-sortIcon>
            </th>
            <th class="city" pSortableColumn="city">
              City
              <p-sortIcon field="city"></p-sortIcon>
            </th>
            <th class="state" pSortableColumn="state">
              State
              <p-sortIcon field="state"></p-sortIcon>
            </th>
            <th class="country">Last order date</th>
          </tr>

          <tr>
            <th></th>
            <th></th>
            <th>
              <div class="d-flex">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  name="street"
                  id="street"
                  style="max-width: 200px"
                  (input)="
                    dt.filter($any($event.target).value, 'street', 'contains')
                  "
                  placeholder=""
                  class="p-column-filter p-inputtext p-component" />
              </div>
            </th>
            <th>
              <div class="d-flex">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  name="city"
                  id="city"
                  style="max-width: 200px"
                  (input)="
                    dt.filter($any($event.target).value, 'city', 'contains')
                  "
                  placeholder=""
                  class="p-column-filter p-inputtext p-component" />
              </div>
            </th>
            <th>
              <div class="d-flex">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  name="state"
                  id="state"
                  style="max-width: 200px"
                  (input)="
                    dt.filter($any($event.target).value, 'state', 'contains')
                  "
                  placeholder=""
                  class="p-column-filter p-inputtext p-component" />
              </div>
            </th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-customerList let-rowIndex="rowIndex">
          <tr
            class="p-selectable-row mousepointer"
            (click)="onClientSelection(customerList, custProgramPopover)">
            <td class="name mousepointer">
              {{ customerList.organizationNameD365 }}
            </td>
            <td class="vaccount mousepointer">
              {{ customerList.clientAccount }}
            </td>
            <td style="width: 200px" class="sname mousepointer">
              {{ customerList.street }}
            </td>
            <td class="city mousepointer">{{ customerList.city }}</td>
            <td style="width: 72px" class="state mousepointer">
              {{ customerList.state }}
            </td>
            <td style="width: 75px" class="country mousepointer">
              {{ customerList.lastOrderDate | date: "yyyy-MM-dd" }}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="20">No client found.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-popover>
</div>
